import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["as", "children"],
    _excluded2 = ["theme", "$styles", "$align", "$color", "$transparency"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled from 'styled-components';
import { convertLayoutProps } from '../../utils';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * This function should not be reused. It's used only to remove
 * the use of the `transparentize` function from `polish` because
 * we moved to using css variables.
 *
 * @deprecated
 */
var getOpacity = function getOpacity($transparency) {
  if (typeof $transparency !== 'number' || !$transparency) {
    return {};
  }

  return {
    opacity: 1 - $transparency
  };
};

var TextWithRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$as = props.as,
      Element = _props$as === void 0 ? 'p' : _props$as,
      children = props.children,
      restProps = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_jsx(Element, _objectSpread(_objectSpread({
    ref: ref
  }, restProps), {}, {
    children: children
  }));
});
TextWithRef.displayName = 'TextWithRef';
var Text = styled(TextWithRef).withConfig({
  displayName: "Text",
  componentId: "sc-wsqynr-0"
})(["overflow-wrap:break-word;word-wrap:break-word;", " ", ";"], function (_ref) {
  var theme = _ref.theme,
      $variant = _ref.$variant;
  return theme.expandVariants($variant, theme.typography.paragraphs);
}, function (_ref2) {
  var theme = _ref2.theme,
      $styles = _ref2.$styles,
      $align = _ref2.$align,
      _ref2$$color = _ref2.$color,
      $color = _ref2$$color === void 0 ? 'primaryIndigo' : _ref2$$color,
      _ref2$$transparency = _ref2.$transparency,
      $transparency = _ref2$$transparency === void 0 ? 0 : _ref2$$transparency,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return theme.normalizeStyles(_objectSpread(_objectSpread(_objectSpread({}, convertLayoutProps(props)), {}, {
    color: theme.colors[$color],
    textAlign: $align
  }, getOpacity($transparency)), $styles));
});
Text.displayName = 'Text';
export default Text;